import { Helmet } from "react-helmet-async";

// Per-page SEO with Open Graph, hreflang and optional JSON-LD structured data.
export const SEO = ({ title, description, path = "", lang = "fr", image, jsonLd }) => {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const url = `${origin}${path}`;
  const langMap = { fr: "fr-FR", it: "it-IT", en: "en-GB" };
  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="O'Lime Design" />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}

      <link rel="alternate" hrefLang="fr" href={url} />
      <link rel="alternate" hrefLang="it" href={url} />
      <link rel="alternate" hrefLang="en" href={url} />
      <link rel="alternate" hrefLang="x-default" href={url} />
      <meta property="og:locale" content={langMap[lang] || "fr-FR"} />

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};
